import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./HeroBanner.css";
import banner1 from "../../assets/Institute/NIECCE-SLIDER-1.jpg";
import banner2 from "../../assets/Institute/NIECCE-SLIDER-2.jpg";
import banner3 from "../../assets/Institute/NIECCE-SLIDER-3.jpg";

const HeroBanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
  };

  const banners = [
    {
      image: banner1,
      title: "Nurturing Future Educators",
      subtitle: "Join the legacy of excellence in Early Childhood Education.",
      link: "/courses",
      btnText: "Explore Courses",
    },
    {
      image: banner2,
      title: "Shaping Bright Minds Since 2004",
      subtitle: "Empowering teachers with world-class training.",
      link: "/about",
      btnText: "Know More",
    },
    {
      image: banner3,
      title: "Transform Your Teaching Career",
      subtitle: "Enroll today and inspire tomorrow’s leaders.",
      link: "/admission",
      btnText: "Join Now",
    },
  ];

  return (
    <section className="hero-banner">
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <div key={index} className="banner-slide">
            <img
              src={banner.image}
              alt={`${banner.title} at NIECCE`}
              title={`${banner.title} at NIECCE`}
              className="banner-bg"
            />

            <div className="banner-overlay" />

            <motion.div
              className="banner-content text-center text-light"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              {index === 0 ? (
                <h1 className="banner-title">Teacher Training Institute in Bangalore</h1>
              ) : (
                <h2 className="banner-title">{banner.title}</h2>
              )}
              <p className="banner-subtitle">{banner.subtitle}</p>
              <Link to={banner.link} className="banner-btn">
                {banner.btnText}
              </Link>
            </motion.div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroBanner;
